/* STRIPE */
export const ISSUE_CARD_LIST = 'ISSUE_CARD_LIST';
export const ISSUE_CARD_LIST_SUCCESS = 'ISSUE_CARD_LIST_SUCCESS';
export const ISSUE_CARD_LIST_FAILED = 'ISSUE_CARD_LIST_FAILED';
export const TRANSACTIONS = 'TRANSACTIONS';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_FAILED = 'TRANSACTIONS_FAILED';
